import type { Product3dConfig } from '../../../services/productApi';

const loadedUrls = new Set<string>();

function preloadUrl(url: string | undefined): void {
	if (!url || loadedUrls.has(url)) return;
	fetch(url)
		.then(() => {
			loadedUrls.add(url);
		})
		.catch((error) => {
			console.warn(`Failed to preload model asset: ${url}`, error);
		});
}

export function preloadModelAssets(
	config3d: Product3dConfig | undefined,
): void {
	if (!config3d) return;
	preloadUrl(config3d.modelUrl);
}
